import { ExternalLink } from "lucide-react";

export default function DashboardFooterBanner() {
  return (
    <div className="mt-16 mb-8">
      <div className="bg-white border-2 border-black p-3 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          {/* Text */}
          <div className="flex-1">
            <p className="text-xs text-gray-700 text-center sm:text-left">
              If you haven't already check out our consumer site{" "}
              <span className="font-bold text-black">The Content Group</span>{" "}
              for further details on what we do
            </p>
            <p className="text-xs text-gray-500 text-center sm:text-left mt-1">
              All information is strictly private and confidential and copyright
              to The Content Group Limited
            </p>
          </div>

          {/* CTA Button */}
          <a
            href="https://thecontentgroup.co"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 inline-flex items-center gap-2 px-4 py-2 bg-black text-white font-bold text-xs uppercase tracking-wide border-2 border-black hover:translate-y-[-2px] hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] transition-all"
          >
            Visit Site
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  );
}
